export const CDN_URL = 'https://js.chargify.com/latest/chargify.js';

export const SDK_VARIABLE = 'Chargify';
